import { gql } from '@apollo/client';

/**
 * Mutation to confirm multiple orders at once
 * Returns either a success or error response with appropriate type discrimination
 *
 * @param ids - Array of order IDs to confirm
 */
export const BatchOrderConfirmMutation = gql`
  mutation BatchOrderConfirm($ids: [ID!]!) {
    batchOrderConfirm(ids: $ids) {
      ... on BatchOrderConfirmSuccess {
        responseType
        __typename
      }
      ... on BatchOrderConfirmError {
        responseType
        message
        __typename
      }
      __typename
    }
  }
`;
